'use strict';

const CORE_PAGES = {
    SUBSCRIPTION_TUNNEL: 'SUBSCRIPTION_TUNNEL',
    OFFER_MANAGEMENT: 'OFFER_MANAGEMENT',
    PAYMENTS_MANAGEMENT: 'PAYMENTS_MANAGEMENT',
    PAYMENT_MODE_UPDATE: 'PAYMENT_MODE_UPDATE',
    OFFER_UPDATE: 'OFFER_UPDATE'
};

const MODAL_BODY_CONTENT = `
    <div class="modal-core">
        <sfra-abo-modal-root></sfra-abo-modal-root>
    </div>
`;

const QUERY_PARAMS = {
    OPEN_CORE_MODAL: 'openShadowDomModal',
    SUB_ORIGIN: 'subOrigin'
};

const SCRIPT_LOADED_EVENT = 'CoreAppLoaded';

/**
 * Open the core app
 * @param {string} page the page to open in the app
 * @param {string=} titleId the title div to update
 * @param {Object=} additionalData the additional data to pass to the app
 * @param {boolean} isModal isModal
 */
function openCoreApp(page, titleId, additionalData, isModal = false) {
    let dataObj = {};
    if (titleId) {
        dataObj.titleId = titleId;
    }
    switch (page) {
        case CORE_PAGES.SUBSCRIPTION_TUNNEL:
            dataObj.groupOffer = 'ABO-CLUB';
            dataObj.tokenInvit = window.appData.resources.TOKEN_INVITATION;
            dataObj.SUBSCRIPTION_URL = window.location.href;
            break;
        case CORE_PAGES.OFFER_MANAGEMENT:
        case CORE_PAGES.PAYMENTS_MANAGEMENT:
        case CORE_PAGES.PAYMENT_MODE_UPDATE:
        case CORE_PAGES.OFFER_UPDATE:
            dataObj.cardNo = window.appData.resources.CARD_NO;
            break;
        default:
            // nothing to do
            break;
    }

    let eventName = isModal ? 'AboModalAppInit' : 'AboAppInit';
    const event = new CustomEvent(eventName, {
        detail: {
            page,
            store: window.appData.resources.STORE,
            locale: window.appData.resources.LOCALE,
            proxyURL: window.appData.resources.SFRA_URLS.CORE_PROXY,
            data: Object.assign(dataObj, additionalData)
        }
    });
    window.dispatchEvent(event);
}

/**
 * Show the side modal
 */
function showSideModal() {
    const sideModal = $('#sideModal');
    sideModal.addClass('modal-close-refresh');
    sideModal.modal('show');
}

/**
 * Redirect the user to the login page with a redirect URL that reopens the tunnel after login
 * @param {string} page - The core page identifier to open after login
 * @param {string} origin - the origin of the call
 */
function redirectToLogin(page, origin) {
    const url = new URL(window.location.href);

    const params = new URLSearchParams(url.search);
    params.set(QUERY_PARAMS.OPEN_CORE_MODAL, page);
    if (origin) {
        params.set(QUERY_PARAMS.SUB_ORIGIN, origin);
    }
    const targetUrl = url.origin + url.pathname + '?' + params.toString();

    window.location.href = window.appData.resources.LOGIN_URL + '?redirectUrl=' + encodeURIComponent(targetUrl);
}

/**
 * Display the app tunnel
 * @param {string} page - The core page identifier to open in the modal
 * @param {string} origin - the origin of the call
 */
function displayAppTunnel(page, origin) {
    const isHardLogin = window.appData.resources.IS_HARD_LOGIN;
    if (isHardLogin) {
        const modalBody = document.querySelector('#sideModal .modal-body');
        modalBody.innerHTML = MODAL_BODY_CONTENT;
        const additionalData = {};
        if (origin) {
            additionalData.SUBSCRIPTION_ORIGIN = origin;
        }
        openCoreApp(page, 'sideModalTitleText', additionalData, true);
        showSideModal();
    } else {
        redirectToLogin(page, origin);
    }
}

module.exports = {
    CORE_PAGES: CORE_PAGES,
    MODAL_BODY_CONTENT: MODAL_BODY_CONTENT,
    QUERY_PARAMS: QUERY_PARAMS,
    SCRIPT_LOADED_EVENT: SCRIPT_LOADED_EVENT,
    openCoreApp: openCoreApp,
    showSideModal: showSideModal,
    redirectToLogin: redirectToLogin,
    displayAppTunnel: displayAppTunnel
};
